import { Link } from 'react-router-dom';

import { useCartCount } from '@/store/cart';

import styles from './CartLink.module.css';

interface CartLinkProps {
  onClick?: () => void;
}

export default function CartLink({ onClick }: CartLinkProps) {
  const count = useCartCount();
  return (
    <Link to="/checkout" className={styles.root} onClick={onClick} aria-label="Cart">
      <span>CART</span>
      <span className={styles.count}>[{String(count).padStart(2, '0')}]</span>
    </Link>
  );
}
